const prefix = 'INVENTORY_SUPPLIER';

export const INVENTORY_SUPPLIER_PAGE_REQUEST = `${prefix}_PAGE_REQUEST`;

export const INVENTORY_SUPPLIER_SUPPLIERS_REQUEST = `${prefix}_SUPPLIER_REQUEST`;

export const INVENTORY_SUPPLIER_SUPPLIERS_LOAD_MORE = `${prefix}_SUPPLIER_LOAD_MORE`;

export const INVENTORY_SUPPLIER_SET_OUTLETS = `${prefix}_SET_OUTLETS`;

export const INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD = `${prefix}_ON_CHANGE_KEYWORD`;

export const INVENTORY_SUPPLIER_SET_SUPPLIERS = `${prefix}_SET_SUPPLIERS`;

export const INVENTORY_SUPPLIER_SET_NEXT_CURSOR = `${prefix}_SET_NEXT_CURSOR`;

export const INVENTORY_SUPPLIER_EXPORT_SUPPLIER = `${prefix}_EXPORT_SUPPLIER`;

export const INVENTORY_SUPPLIER_SET_PROFILE = `${prefix}_SET_PROFILE`;

export const INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN = `${prefix}_OPEN_RIGHT_COLUMN`;

export const INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN = `${prefix}_CLOSE_RIGHT_COLUMN`;

export const INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER = `${prefix}_ASK_DELETE_SUPPLIER`;

export const INVENTORY_SUPPLIER_ON_CLICK_ROW = `${prefix}_ON_CLICK_ROW`;

export const INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL = `${prefix}_SET_SUPPLIER_DETAIL`;

export const INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE = `${prefix}_SUBMIT_FORM_CREATE`;

export const INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE = `${prefix}_SUBMIT_FORM_UPDATE`;

export const INVENTORY_SUPPLIER_ON_CLICK_CANCEL = `${prefix}_ON_CLICK_CANCEL`;

export const INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER = `${prefix}_CANCEL_DELETE_SUPPLIER`;

export const INVENTORY_SUPPLIER_DELETE_SUPPLIER = `${prefix}_DELETE_SUPPLIER`;

export const INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL = `${prefix}_OPEN_DELETE_SUPPLIER_MODAL`;

export const INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL = `${prefix}_CLOSE_DELETE_SUPPLIER_MODAL`;

export const INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER = `${prefix}_ON_CLICK_CREATE_SUPPLIER`;

export const INVENTORY_SUPPLIER_IS_SUBMITTING_FORM = `${prefix}_IS_SUBMITTING_FORM`;

export const INVENTORY_SUPPLIER_EXPORT_START = `${prefix}_IS_START_EXPORTING`;

export const INVENTORY_SUPPLIER_EXPORT_DONE = `${prefix}_IS_DONE_EXPORTING`;

export const INVENTORY_SUPPLIER_EXPORT_FAILED = `${prefix}_IS_FAILED_EXPORTING`;

export const INVENTORY_SUPPLIER_SET_ASYNCJOBID = `${prefix}_SET_ASYNCJOBID`;
